const isDev = process.env.NODE_ENV === 'development'

const config = {
  apiUrl: process.env.API_URL || isDev ? 'http://localhost:8080' : '/api',
  host: process.env.HOST || 'http://lk.grottbjorn.com',
  serverUrl: process.env.NEXT_PUBLIC_SERVER_URL || "https://grottbjorn.com",
}

module.exports = config



// WEBPACK FOOTER //
// ./src/config.js